export default function SidebarNewsCardSkeleton() {
  return (
    <div className="space-y-3">
      {Array.from({ length: 4 }, (_, index) => (
        <div
          key={index}
          className="flex items-start gap-3 p-2 border-b border-gray-100 last:border-b-0 animate-pulse"
        >
          {/* News source logo */}
          <div className="w-10 h-10 bg-gray-200 rounded flex-shrink-0"></div>

          {/* News content */}
          <div className="flex-1 space-y-1">
            {/* News title */}
            <div className="h-4 bg-gray-200 rounded w-full"></div>
            <div className="h-4 bg-gray-200 rounded w-4/5"></div>

            {/* News source and time */}
            <div className="flex items-center gap-2 mt-2">
              <div className="h-3 bg-gray-200 rounded w-16"></div>
              <div className="w-1 h-1 bg-gray-200 rounded-full"></div>
              <div className="h-3 bg-gray-200 rounded w-12"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
